module.exports = __webpack_public_path__ + "img/networks-1.6849ee2b.png";